/**
 * Equivalent to:
 * date.toLocaleString('en-US', {
 *     relative: false,
 *     month: 'short',
 *     day: 'numeric'
 * })
 *
 * ie. "Jun 8" or "Feb 27"
 * without relying on the Intl.DateTimeFormat API.
 */
export function getShortDate(date: Date): string {
    return `${getShortMonthName(date)} ${date.getDate()}`;
}

const MONTHS_MAP = {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
};

/**
 * Returns the short month name for a given date.
 */
export function getShortMonthName(date: Date): string {
    const month = date.getMonth() + 1;
    return MONTHS_MAP[month];
}

/**
 * Format date as MM/DD/YYYY (e.g., "05/11/2025")
 */
export function formatNumericDate(date: Date): string {
    return new Intl.DateTimeFormat('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        timeZone: 'UTC',
    }).format(date);
}

/**
 * Format date as "Month Day, Year" (e.g., "November 5, 2025")
 */
export function formatDateFull(date: Date): string {
    return new Intl.DateTimeFormat('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'UTC',
    }).format(date);
}

/**
 * Format date as "Nov. 5 2025"
 */
export function formatDateShort(date: Date): string {
    return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'UTC',
    }).format(date);
}
